import PropTypes from "prop-types"
import { map } from "lodash"
import classNames from "classnames"
import ItemCell from "./item-cell"
import { GroupColumn, BackgroundColorLayer, loadingShimmer } from "../styled"

export default function Column({ id, data, items, column, cellWidth, getBackgroundColor, scrollable, isLastColumn }) {
  const { noData, isUnmodeled, color } = column
  const loading = !data && !noData && !isUnmodeled

  return (
    <GroupColumn
      className={classNames("group-column", { loading })}
      sx={{
        ...(scrollable && {
          flex: isLastColumn ? "0 0 calc((100% / 5) - 12px)" : "0 0 calc((100% + 15px) / 5)",
        }),
        ...(loading && {
          backgroundSize: "400% 400% !important",
          animation: `${loadingShimmer} 6s linear infinite`,
        }),
      }}
    >
      <BackgroundColorLayer className="background-color" style={getBackgroundColor(loading, color)} />
      {map(items, (item, j) => <ItemCell
        key={`${id}-row${j}`}
        item={item}
        width={cellWidth}
        color={color}
        loading={loading}
        chartBarFallbackWidth="80%"
        compactValuePadding={isLastColumn && scrollable}
      />,
      )}
    </GroupColumn>
  )
}
Column.propTypes = {
  id: PropTypes.string,
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    noData: PropTypes.bool,
    isUnmodeled: PropTypes.bool,
  }).isRequired,
  items: PropTypes.array.isRequired,
  data: PropTypes.object,
  cellWidth: PropTypes.number.isRequired,
  getBackgroundColor: PropTypes.func.isRequired,
  scrollable: PropTypes.bool,
  isLastColumn: PropTypes.bool,
}
